import { useNavigate } from 'react-router-dom';

export default function DemoPending() {
    const navigate = useNavigate();
    return (
        <div className="gmw gmw-pending">
            <div className="pending-card fade-up">
                <div className="pending-icon">⏳</div>
                <div className="auth-card-title" style={{ marginBottom: 8 }}>승인 대기 중</div>
                <div className="auth-card-sub" style={{ marginBottom: 20 }}>
                    회원가입 신청이 완료되었습니다.<br />
                    관리자 검토 후 승인 이메일이 발송됩니다.<br />
                    통상 1~2 영업일 내 처리됩니다.
                </div>
                <div style={{ background: 'var(--surface2)', border: '1.5px solid var(--border)', borderRadius: 'var(--radius)', padding: 14, marginBottom: 22, textAlign: 'left' }}>
                    <div className="form-label" style={{ marginBottom: 10 }}>신청 정보</div>
                    <div className="compare-row"><span className="compare-lbl">회사명</span><span style={{ fontSize: 12.5, fontWeight: 700 }}>(주)그린조경개발</span></div>
                    <div className="compare-row"><span className="compare-lbl">이메일</span><span style={{ fontSize: 12.5, fontWeight: 700 }}>admin@greenland.kr</span></div>
                    <div className="compare-row" style={{ borderBottom: 'none' }}><span className="compare-lbl">신청일시</span><span style={{ fontSize: 12, fontFamily: 'var(--mono)', fontWeight: 600 }}>2026.01.15 14:32</span></div>
                </div>
                <button className="btn btn-secondary w-full" onClick={() => navigate('/demo/login')}>로그인 화면으로</button>
            </div>
        </div>
    );
}
